const route = () => `/documents`;

export default route;
